// extracted by mini-css-extract-plugin
export default {"button_":"button_button___B+58C"};